import FolderCard from './FolderCard.jsx'
export default FolderCard 